<template>
  <div>
    <div :id="chartId" :style="{ height: height, width: width }"></div>
  </div>
</template>

<script>
    import echarts from 'echarts';

    export default {
        name: 'BarChart',
        props: {
            chartId: {
                // 图表 id
                type: String,
                default: 'myBarChart'
            },
            height: {
                // 图表高度
                type: String,
                default: '248px'
            },
            width: {
                // 图表宽度
                type: String,
                default: '100%'
            },
            bottom: {
                type: String,
                default: '0%'
            },
            dataset: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        data () {
            return {
                chartData: []
            };
        },
        mounted () {
            this.chartData = this.dataset;
        },
        watch: {
            dataset (newValue, oldValue) {
                if (JSON.stringify(newValue) !== JSON.stringify(this.chartData)) {
                    this.chartData = newValue
                    if (this.dataset.length > 0) {
                        this.drawLine();
                    }
                }
                // if(newValue.length == 0 || newValue[0].source == null ||newValue[0].source.length == 0){
                // this.chartData =  {
                //         dimensions: ["name", "value"],
                //         source: [[' ',0]],
                //       };
                // }else{
                // this.chartData = newValue;
                // }
                // this.drawLine();
            }
        },
        methods: {
            drawLine () {
                let myBarChart = echarts.init(document.getElementById(this.chartId));
                myBarChart.setOption({
                    tooltip: {
                        position: 'inside',
                        axisPointer: {
                            type: 'none' // 去掉点击出现的横线
                        },
                        trigger: 'item',
                        triggerOn: 'click',
                        formatter: function (params) {
                            console.log(params)
                            return `<div>${params.value[0]}: ${params.value[1]}起</div>`
                        }
                    },
                    dataset: this.chartData,
                    dataZoom: [
                        {
                            show: false,
                            realtime: true,
                            start: 0,
                            end: 80
                        },
                        {
                            type: 'inside',
                            realtime: false,
                            start: 0,
                            end: 80
                        }
                    ],
                    grid: {
                        // left:
                        //   this.fieldServiceData && this.fieldServiceData.tag == "万元"
                        //     ? "7%"
                        //     : "5%",
                        // left: '7%',
                        left: '0%',
                        right: '0%',
                        top: 45,
                        bottom: this.bottom,
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        axisTick: {
                            show: false
                        },
                        splitLine: { show: false },
                        axisLine: { show: false },
                        axisLabel: {
                            interval: 0,
                            textStyle: {
                                color: '#71747A'
                            },
                            formatter: function (params) {
                                return params.replace(/省|市|特别行政区|回族|维吾尔|自治区|壮族自治区/g, '');
                                // return params.split("").join("\n")
                            }
                        }
                    },
                    yAxis: {
                        axisLine: { show: false },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                type: 'dashed',
                                color: '#E0E0E0'
                            }
                        },
                        type: 'value',
                        name: this.dataset[0].tag
                            ? '单位（' + this.dataset[0].tag + '）'
                            : '单位（起）',
                        nameTextStyle: {
                            color: '#C8C9CC',
                            padding: [0, 0, 10, 15]
                        },
                        axisLabel: {
                            textStyle: {
                                color: '#C8C9CC'
                            }
                        },
                        splitNumber: 4
                    },
                    series: [
                        {
                            type: 'bar',
                            barWidth: 12,
                            itemStyle: {
                                normal: {
                                    color: '#36B374',
                                    label: {
                                        show: true,
                                        position: 'top',
                                        textStyle: {
                                            color: '#36B374',
                                            fontSize: 12
                                        }
                                    }
                                }
                            }
                        }
                    ]
                });
            }
        }
    };
</script>
